import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const manualDeploy = async () => {
  const resp = await api.post("/v2/manual-deploy", {});
  return resp.data;
};

export const useManualDeploy = () => {
  return useMutation({
    mutationFn: async () => manualDeploy(),
    onSuccess: () => {
      toast.success("Manual Deploy Successful!");
    },
  });
};
